// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-title-div {
  display: flex;
  justify-content: center;
  padding-top: "0px";
  padding-bottom: 5vh;
}

.home-title {
  font-size: 30px;
  font-weight: 500;
}

.ad-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  padding-block: 2%;
}

.ad-btn {
  width: 40%;
  cursor: pointer;
}

.ad-image {
  width: 100%;
  border-radius: 10px;
  height: auto;
  margin: 5px;
}

.midSection-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.home-search-div {
  display: flex;
  justify-content: center;
  margin-bottom: 5vh;
}

.home-search-textfield {
  width: 50%;
}

.home-search-btn {
  width: 15%;
  max-width: 80px;
  border-radius: 10px;
  margin-left: 2%;
  text-transform: none;
}

.home-search-clear-btn {
  width: 15%;
  max-width: 80px;
  border-radius: 10px;
  margin-left: 2%;
  text-transform: none;
}

.home-table-div {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 5vh;
}

/*LARGE*/
@media screen and (min-width: 768px) {
  .home-title {
    font-size: 30px;
    font-weight: 500;
  }

  .ad-container {
    justify-content: center;
    align-items: center;
  }

  .ad-btn {
    width: 250px;
  }

  .midSection-container {
    flex-direction: row;
  }

  .home-search-div {
    justify-content: flex-start;
    width: 70%;
  }

  .home-search-textfield {
    width: 60%;
  }

  .home-search-btn {
    width: 80px;
    margin-left: 10px;
  }

  .home-search-clear-btn {
    width: 80px;
    margin-left: 10px;
  }

  .home-table-div {
    width: 90%;
    margin-left: 5%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Home/home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,QAAQ;AACR;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF","sourcesContent":[".home-title-div {\n  display: flex;\n  justify-content: center;\n  padding-top: \"0px\";\n  padding-bottom: 5vh;\n}\n\n.home-title {\n  font-size: 30px;\n  font-weight: 500;\n}\n\n.ad-container {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n  padding-block: 2%;\n}\n\n.ad-btn {\n  width: 40%;\n  cursor: pointer;\n}\n\n.ad-image {\n  width: 100%;\n  border-radius: 10px;\n  height: auto;\n  margin: 5px;\n}\n\n.midSection-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n\n.home-search-div {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 5vh;\n}\n\n.home-search-textfield {\n  width: 50%;\n}\n\n.home-search-btn {\n  width: 15%;\n  max-width: 80px;\n  border-radius: 10px;\n  margin-left: 2%;\n  text-transform: none;\n}\n\n.home-search-clear-btn {\n  width: 15%;\n  max-width: 80px;\n  border-radius: 10px;\n  margin-left: 2%;\n  text-transform: none;\n}\n\n.home-table-div {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 5vh;\n}\n\n/*LARGE*/\n@media screen and (min-width: 768px) {\n  .home-title {\n    font-size: 30px;\n    font-weight: 500;\n  }\n\n  .ad-container {\n    justify-content: center;\n    align-items: center;\n  }\n\n  .ad-btn {\n    width: 250px;\n  }\n\n  .midSection-container {\n    flex-direction: row;\n  }\n\n  .home-search-div {\n    justify-content: flex-start;\n    width: 70%;\n  }\n\n  .home-search-textfield {\n    width: 60%;\n  }\n\n  .home-search-btn {\n    width: 80px;\n    margin-left: 10px;\n  }\n\n  .home-search-clear-btn {\n    width: 80px;\n    margin-left: 10px;\n  }\n\n  .home-table-div {\n    width: 90%;\n    margin-left: 5%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
